<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("query reason code") }}</label>
          <div class="select">
            <select v-model="meta.query_reason_code">
              <option value="1">{{ $t("new credit") }}</option>
              <option value="2">{{ $t("extension") }}</option>
              <option value="3">{{ $t("renovation") }}</option>
              <option value="4">{{ $t("restructuring") }}</option>
              <option value="5">{{ $t("valuation") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("figure code") }}</label>
          <div class="select">
            <select v-model="meta.figure_code">
              <option value="1">
                {{ $t("debtor holder or responsible for the account") }}
              </option>
              <option value="2">{{ $t("other debtor holders") }}</option>
              <option value="3">{{ $t("co-debtor or guarantor") }}</option>
              <option value="4">{{ $t("avalist") }}</option>
              <option value="5">{{ $t("legal representative") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("correlative") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.correlative"
              :placeholder="$t('correlative')"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("request number") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.request_number"
              placeholder="653278"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("person code") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.person_code"
              placeholder="6284"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("periodicity") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.periodicity"
              placeholder="1"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query date") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.query_date"
              placeholder="31012024"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("credit asset number") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.credit_asset_number"
              placeholder="56354115"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Process_11",
  data() {
    return {
      meta: {
        correlative: "",
        query_reason_code: "",
        request_number: "",
        figure_code: "",
        person_code: "",
        periodicity: "",
        query_date: "",
        credit_asset_number: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
  },
};
</script>

<style scoped>
/* Your component styles go here */
</style>
